import { render, staticRenderFns } from "./properties-block-search.vue?vue&type=template&id=746ec778&scoped=true"
import script from "./properties-block-search.vue?vue&type=script&lang=js"
export * from "./properties-block-search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746ec778",
  null
  
)

export default component.exports